export const validateEmailAddress = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return emailRegex.test(email);
};

export const isOnlyLetters = (value, language) => {
  const regexByLanguage = {
    "en-US": /^[A-Za-z ]+$/,
    "he-IL": /^[a-zA-Zא-ת\s]*$/,
  };

  const regex = regexByLanguage[language] || regexByLanguage["en-US"];
  return regex.test(value);
}

export const isExistNumbers = (value) => {
  const numbers = /^[0-9]+$/;
  return numbers.test(value);
}